<template>
  <div class="body">
    <div class="box">
      <H5Header/>
      <div class="dtgk" :style="{'background-image': `url(${img ? $baseURL + img : require('./image/dtgk.png')})`}">
        <div class="bigtitle">{{ currentItem.name }}</div>
        <!--				<div class="smalltitle">DYNAMIIC GENERALIZATION</div>-->
      </div>
      <div class="nav_position">
        <ul>
          <div class="homeIcon"><img src="./image/home.png"></div>
          <li>当前位置 ：</li>
          <li>
            <a href="index.html">首页</a><span>&gt;</span>
          </li>
          <li v-if="leftData.length > 0"><a href="" v-if="leftData.length>0">{{ leftData[0].name }}</a><span>&gt;</span>
          </li>
          <li class="last" id="currentColumn" v-if="leftData.length > 0"><a>{{ currentItem.name }}</a></li>
        </ul>
      </div>
      <div class="conList" v-if="leftData.length > 0">
        <div class="swiper-container" ref="swiperContainer">
          <div class="swiper-wrapper"
               v-if="(leftData.length > 0 && leftData[0].template != 'picture_column') || pid !=0">
            <div class="swiper-slide"
                 v-for="(item,index) in visibleSlides"
                 :key="index"
                 :style="{width: slideWidth + '%'}">
              <p :style="{'color': currentNavId == item.id ? 'rgb(57, 155, 218)':'#000'}"
                 @click="navTo(item)">
                {{ item.name }}
              </p>
            </div>
          </div>
        </div>
        <!-- 左右箭头 -->
        <div class="swiper-button-next"
             :class="{'swiper-button-disabled': !showNextButton}"
             @click="nextSlide">
        </div>
        <div class="swiper-button-prev"
             :class="{'swiper-button-disabled': !showPrevButton}"
             @click="prevSlide">
        </div>
      </div>
      <div v-if="currentItem.template == 'channel' && !sij">
        <div class="viewbox">
          <div class="newsitem-title">
            {{ articleDetail.title }}
          </div>
          <div class="source">
            <div class="line">
              <div class="l-1">
                来源:
              </div>
              <div class="l-2">
                {{ articleDetail.source }}
              </div>
            </div>
            <div class="line">
              <div class="l-1">
                时间:
              </div>
              <div class="l-2">
                {{ articleDetail.createTime }}
              </div>
            </div>
          </div>
          <div class="content">
            <div v-html="articleDetail.content || ''"></div>
          </div>
        </div>
      </div>
      <div v-if=" (currentItem.template == 'common_list' || currentItem.template == 'date_list' || currentItem.template == 'picture') && !sij" class="listbox">
        <ol class="list" style="margin-bottom: 20px">
          <template v-if="cate && cate.length>0">
            <li class="listitem" v-for="item in cate" :key="item.id">
              <div class="circle"></div>
              <div class="itemtext maxline1"><a href="javascript:;"
                                                @click="toDetail(item, currentItem.name)">{{ item.title }}</a></div>
              <div class="date">{{ item.publishTime.split(' ')[0] }}</div>
            </li>
          </template>
          <li class="listitem" v-else>
            暂无数据
          </li>
        </ol>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-size="pageSize"
            small
            layout="prev, pager, next,total"
            :total="total">
        </el-pagination>
      </div>
    </div>
    <div v-if="sij">
      <div class="listbox" v-for="(item,index) in sijList" :key="index">
        <div class="navtitle">
          <div class="itemtitle">{{ item.name }}</div>
          <!--					<button class="more">更多</button>-->
        </div>
        <hr>
        <div v-if="item.template == 'common_list' || item.template == 'date_list'">
          <ol class="list" style="margin-bottom: 20px">
            <template v-if="item.list.list &&item.list.list.length>0">
              <li class="listitem" v-for="ite in item.list.list" :key="ite.id">
                <div class="circle"></div>
                <div class="itemtext maxline1"><a href="javascript:;"
                                                  @click="toDetail(ite,  item.name)">{{ ite.title }}</a></div>
                <div class="date">{{ ite.publishTime.split(' ')[0] }}</div>
              </li>
            </template>
            <li class="listitem" v-else>
              暂无数据
            </li>
          </ol>
          <el-pagination
              @current-change="(page) => handleCurrentChangecommon(page, item)"
              :current-page="item.pageNum"
              :page-size="item.pageSize"
              small
              layout="prev, pager, next,total"
              :total="item.list.total">
          </el-pagination>
        </div>
        <div class="content" v-if="item.template == 'channel' ">
          <div v-html="item.list.content"></div>
        </div>
        <div class="content" v-if="item.template == 'picture' ">
          <div class="content_wrap wenti" id="contents2">
            <ul class="img_list" v-if="item.list.list &&item.list.list.length>0">
              <li v-for="ite in item.list.list" :key="ite.id"><p class="peoImg">
                <img :src="$baseURL + ite.imgUrl" @click="toDetail(ite,  item.name)"></p>
                <p class="textPeo">{{ ite.title }}</p>
              </li>
            </ul>
            <li class="listitem" v-else>
              暂无数据
            </li>
          </div>
          <el-pagination
              @current-change="(page) => handleCurrentChangecommon(page, item)"
              :current-page="item.pageNum"
              :page-size="item.pageSize"
              small
              layout="prev, pager, next,total"
              :total="item.list.total">
          </el-pagination>
        </div>
        <div v-if="item.template == 'picture_list'" style="margin: 26px 0;padding-bottom: 26px">
          <div class="content_wrap zhuanjia" id="contents3" v-for="(ite,num) in item.list.list" :key="num">
            <div class="peoCont">
              <div class="imgIcon"><p class="imgs"><img :src="$baseURL + ite.imgUrl"></p>
                <p class="word"><span class="lanzi">{{ ite.title }}</span></p></div>
              <div class="jieshao" v-html="ite.content"></div>
            </div>
            <div class="line" v-if="Number(num + 1) < item.list.list.length"></div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 10px">

    </div>
    <H5Footer/>
  </div>
</template>

<script>
import H5Header from "./components/header"
import H5Footer from "./components/footer"
import {getArticleById} from "@/network/api";

export default {
  components: {
    H5Header,
    H5Footer
  },
  data() {
    return {
      layer: '',
      zjcx: ['证件号', '企业名称', '证件类别',],
      dtgk: ['动态概括', '中心概括', '中心简介', '中心领导', '发展历程', '组织机构', '办事机构', '中心资源',],
      columnId: '',
      cate: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      pid: '',
      leftData: [],
      currentItem: {},
      articleDetail: {},
      sij: false,
      sijList: [],

      currentNavId: '', // 当前选中的导航ID
      currentSlideIndex: 0, // 当前显示的起始索引
      slidesPerView: 3, // 每页显示3个
      slideWidth: 30, // 每个slide的宽度
      img:''
    }
  },
  computed: {
    // 获取当前可见的slides
    visibleSlides() {
      if (!this.leftData[0] || !this.leftData[0].children) return [];
      const children = this.leftData[0].children;
      return children.slice(this.currentSlideIndex, this.currentSlideIndex + this.slidesPerView);
    },
    // 是否可以点击上一页
    showPrevButton() {
      return this.currentSlideIndex > 0;
    },
    // 是否可以点击下一页
    showNextButton() {
      if (!this.leftData[0] || !this.leftData[0].children) return false;
      return this.currentSlideIndex + this.slidesPerView < this.leftData[0].children.length;
    }
  },
  mounted() {
    this.columnId = this.$route.query.id;
    this.pid = this.$route.query.pid;
    this.currentNavId = this.columnId; // 初始化当前导航ID
    // this.getCateDetail()
    this.getAllColumn()
    // 更安全地获取 slideIndex
    const slideIndexParam = this.$route.query.slideIndex;
    if (slideIndexParam !== undefined && slideIndexParam !== null) {
      this.currentSlideIndex = parseInt(slideIndexParam);
      // 确保是有效的数字
      if (isNaN(this.currentSlideIndex)) {
        this.currentSlideIndex = 0;
      }
    } else {
      this.currentSlideIndex = 0;
    }
  },
  methods: {
    async getAllColumn() {
      let res = await this.$api.getAllColumn({
        pid: this.pid,
        id: this.columnId
      });
      this.leftData = res.data.data.list;
      this.columnPid = res.data.data.pid.parentId
      this.currentNavId = this.columnId;

      // 验证slideIndex是否有效
      const totalChildren = this.leftData[0]?.children?.length || 0;
      if (this.currentSlideIndex < 0) {
        this.currentSlideIndex = 0;
      }
      if (this.currentSlideIndex + this.slidesPerView > totalChildren) {
        this.currentSlideIndex = Math.max(0, totalChildren - this.slidesPerView);
      }

      if(res.data.data.list.length == 0){
        this.$api.getArticleListById({
          id:res.data.data.pid.id,
          pageNum: 1,
          pageSize: 10
        }).then(ret => {
          this.currentItem = res.data.data.pid
          console.log('1111',ret)
          this.cate = ret.data.data.list
          this.total = ret.data.data.total
        });
      }

      if (this.leftData[0]?.children.length > 0) {
        if (this.columnId == this.pid) {
          if (this.leftData[0].template == 'picture_column') {
            //如果是图片栏目
            this.currentItem = this.leftData[0];
          } else if (this.leftData[0]?.children[0]?.children.length > 0) {
            this.currentItem = this.leftData[0].children[0].children[0]
            console.log(0)
          } else {
            this.currentItem = this.leftData[0]?.children[0];
            console.log(1)
            if (this.currentItem.template == 'channel') {
              this.getArticleData(this.currentItem.id)
            }else {
              this.getArticleListById(this.currentItem.id)
            }
          }
        } else if (this.columnPid == this.pid) {
          let index = this.leftData[0]?.children.findIndex(item => item.id == this.columnId);
          this.currentItem = this.leftData[0]?.children[index]?.children[0]
          if (this.leftData[0]?.children[index]?.children.length > 0) {

            this.sij = true
            const children = this.leftData[0]?.children[index]?.children;
            if (children && children.length > 0) {
              const promises = children.map(item => {
                if (!item.hasOwnProperty('pageNum')) {
                  this.$set(item, 'pageNum', 1);
                }
                if (!item.hasOwnProperty('pageSize')) {
                  this.$set(item, 'pageSize', 10);
                }
                if (item.template == 'common_list' || item.template == 'picture' || item.template == 'picture_list' || item.template == 'date_list') {
                  return this.$api.getArticleListById({
                    id: item.id,
                    pageNum: 1,
                    pageSize: 10
                  }).then(res => {
                    item.list = res.data.data;
                    return item;
                  });
                } else if (item.template == 'channel') {
                  return this.$api.getArticleById({
                    id: item.id,
                  }).then(res => {
                    item.list = res.data.data;
                    return item;
                  });
                } else {
                  return Promise.resolve(item);
                }
              });
              await Promise.all(promises);
              this.$forceUpdate();
            }
            this.sijList = this.leftData[0]?.children[index]?.children
            console.log(this.sijList)

            this.currentItem = this.leftData[0].children[index].children[0]
          } else {
            this.currentItem = this.leftData[0]?.children[index]
          }
          console.log(4, this.currentItem)
          this.img = this.leftData[0]?.imgUrl
          this.$forceUpdate();
          console.log( this.leftData[0]?.imgUrl)
          if (this.currentItem.template == 'channel') {
            this.getArticleData(this.columnId)
          }
          if (this.currentItem.template == 'common_list') {
            this.getArticleListById(this.columnId)
          }
          if (this.currentItem.template == 'date_list') {
            this.getArticleListById(this.columnId)
          }
        } else {
          console.log(3)
          this.currentItem = res.data.data.pid
        }
      } else {
        console.log(5)
        this.currentItem = this.leftData[0];
      }
    },
    async getArticleData(id) {
      let res = await this.$api.getArticleById({id: id});
      this.articleDetail = res.data.data;
    },
    async getArticleListById(e) {
      let res = await this.$api.getArticleListById({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        id: e
      })
      this.cate = res.data.data.list
      this.total = res.data.data.total
    },


    switchPage(layer) {
      this.layer = layer ? layer : '';
    },
    async getCateDetail() {
      let res = await this.$api.getH5ArticleList({
        pid: this.columnId,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      })
      console.log(res.data.data, '==========');
      this.cate = res.data.data
      this.total = res.data.data.totalPage
      // this.bg = res.data.data.imgUrl
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getArticleListById(this.columnId)
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getArticleListById(this.columnId)
    },
    toDetail(item, name) {
      console.log(item)
      if (item.type == 2) {
        if (!item.fileUrl) {
          return this.$message.error('暂无文件');
        }
        let url = process.env.VUE_APP_BASE_API + item.fileUrl.replace(/^\//, '')
        window.open(url)
      } else {
        this.$router.push({path: '/h5view', query: {articleId: item.id, name: name}})
      }
    },
    navTo(item) {
      this.currentNavId = item.id;

      const allChildren = this.leftData[0]?.children || [];
      const clickedIndex = allChildren.findIndex(child => child.id === item.id);

      console.log('点击栏目索引:', clickedIndex, '栏目ID:', item.id);
      console.log('所有栏目:', allChildren.map(c => ({id: c.id, name: c.name})));

      if (clickedIndex === -1) {
        console.error('未找到点击的栏目');
        this.$router.push(`h5list?id=${item.id}&pid=${this.pid}`);
        return;
      }

      // 更精确的计算方法
      let slideIndex = this.calculateSlideIndex(clickedIndex, allChildren.length);
      console.log('计算出的slideIndex:', slideIndex);

      this.$router.push(`h5list?id=${item.id}&pid=${this.pid}&slideIndex=${slideIndex}`);
    },

    calculateSlideIndex(clickedIndex, totalLength) {
      // 如果点击的栏目在前3个，显示前3个
      if (clickedIndex < this.slidesPerView) {
        return 0;
      }

      // 如果点击的栏目在最后3个，显示最后3个
      if (clickedIndex >= totalLength - this.slidesPerView) {
        return Math.max(0, totalLength - this.slidesPerView);
      }

      // 其他情况，让点击的栏目显示在中间位置
      return clickedIndex - 1;
    },
    // 智能调整显示位置
    adjustInitialSlidePosition() {
      const allChildren = this.leftData[0]?.children || [];
      const targetIndex = allChildren.findIndex(child => child.id === this.columnId);

      if (targetIndex !== -1 && targetIndex >= this.slidesPerView) {
        this.currentSlideIndex = targetIndex - this.slidesPerView + 1;
        if (this.currentSlideIndex < 0) this.currentSlideIndex = 0;
      }
    },
    async handleCurrentChangecommon(val, item) {
      console.log(val, item)
      let res = await this.$api.getArticleListById({
        pageNum: val,
        pageSize: 10,
        id: item.id
      })
      item.list.list = res.data.data.list
      item.list.total = res.data.data.total
      this.$forceUpdate();
    },
    prevSlide() {
      if (this.showPrevButton) {
        this.currentSlideIndex -= this.slidesPerView;
        if (this.currentSlideIndex < 0) {
          this.currentSlideIndex = 0;
        }
      }
    },
    // 下一页
    nextSlide() {
      if (this.showNextButton) {
        this.currentSlideIndex += this.slidesPerView;
        const totalItems = this.leftData[0].children.length;
        // 确保不会超出范围
        if (this.currentSlideIndex + this.slidesPerView > totalItems) {
          this.currentSlideIndex = totalItems - this.slidesPerView;
        }
      }
    },
  }
}
</script>

<style scoped>
.body {
  width: 100%;
  overflow: scroll;
}

.box {
  margin: auto auto;
  /*width: 320px;*/
  background: #FFFFFF;
}


.dtgk {
  /*width: 320px;*/
  height: 179px;
  background-size: 100% 100%;
}

.bigtitle {
  padding-top: 65px;
  margin-left: 15px;
  font-size: 23px;
  color: #FFFFFF;
}

.smalltitle {
  margin-left: 15px;
  color: #FFFFFF;
  font-size: 12px;
}

.zjcx {

  width: 300px;
  height: 42.5px;
  line-height: 42.5px;
  text-align: center;
  background-color: #244991;
  border-radius: 50px;
  font-size: 18px;
  color: #FFFFFF;
  margin: 0 auto;
  margin-top: 10px;
  margin-bottom: 10px;
}

.tips {
  width: 300px;
  margin: 30px auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-bottom: 20px;
  border-bottom: #ecf5ff 2px solid;
}

.tipstext {
  font-size: 12px;
  font-weight: 400;
  color: #666666;
}

.zxjj {
  color: #cccccc;
}

.tipsmenu {
  margin-left: 80px;
  width: 22px;
  height: 16px;
}

.listbox {
  /* border: solid 2px; */
  /*width: 320px;*/
  /*margin: -20px auto;*/
  padding: 0 20px;
  background: #fff;
}

.navtitle {
  margin: auto auto;
  /*width: 300px;*/
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  box-sizing: content-box;
}

hr {
  margin: -3px auto;
  width: 300px;
  border: #ECF5FF 2px solid;
}

.itemtitle {
  font-size: 15px;
  min-width: 60px;
  font-weight: 600;
  color: #244991;
  border-bottom: #244991 3px solid;
  line-height: 40px;
}

.more {
  margin-top: 15px;
  width: 41px;
  height: 20px;
  border-radius: 4px;
  background-color: #f1f7fe;
  color: #666666;
}

.list {
  margin: 15px auto;
  /*width: 300px;*/
}

.listitem {
  height: 30px;
  font-size: 10px;
  font-weight: 400;
  color: #333333;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.circle {
  margin-top: 12px;
  width: 7px;
  height: 7px;
  border: solid #8A9DC2 2px;
  border-radius: 50%;
}

.itemtext {
  margin-left: 5px;
  width: 243px;
  line-height: 30px;
}

.date {
  line-height: 30px;
  color: #999999;
}

.hzhbbox {
  /*margin-top: 20px;*/
  /*width: 320px;*/
  background: #00337D;
  color: #FFFFFF;
  padding-top: 20px;
  padding-bottom: 20px;
}

.hztitle {
  margin-left: 20px;
  font-weight: 600;
  font-size: 15px;
}

.linebox {
  margin: 10px auto;
  width: 300px;
  height: 42.5px;
  background: #FFFFFF;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.linetext {
  margin: auto auto;
  color: #000000;
  width: 206.5px;
}

.arrow {
  margin: auto auto;
  width: 14px;
  height: 7px;
}

.qrbox {
  /*width: 320px;*/
  background: #09459B;
  padding-bottom: 20px;
  color: #FFFFFF;
}

.arrowtop {
  margin-left: 135px;
  width: 50px;
}

.zbdw {
  font-size: 15px;
  margin: 20px auto;
  width: 300px;
  border-bottom: #888888 2px dashed;
  padding-bottom: 20px;
}

.qrcode {
  margin: 20px 99.5px;
  width: 121px;
}

.kfdh {
  margin-bottom: 20px;
  font-size: 15px;
  margin-left: 10px;
}

.layer {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0%);
  width: 320px;
  background: #000000;
  opacity: 0.9;
  padding-bottom: 20px;
  position: absolute;
}

.dtlayertitle {
  margin: 20px 15px;
  font-size: 18px;
  color: #FFFFFF;
}

.dtlayeritem {
  margin: 20px 10px;
  font-size: 15px;
  color: #FFFFFF;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.layeritemtitle {
  margin-left: 5px;
  color: #FFFFFF;
}

.dtlayermore {
  font-size: 18px;
  color: #2b2b2c;
}

.dtlayerline {
  margin: auto auto;
  width: 300px;
  border: solid 1px #2b2b2c;
}

.zjcxlayer {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0%);
  width: 320px;
  background: #000000;
  opacity: 0.9;
  padding-bottom: 40px;
  padding-top: 5px;
}

.layertitle {
  margin-left: 20px;
  font-size: 15px;
  font-weight: bold;
  color: #FFFFFF;
}

.layerline {
  width: 300px;
  margin: 15px auto;
  border: #244991 1px solid;
}

.zjitem {
  margin: 20px auto;
  width: 300px;
  height: 35px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.zjtitle {
  line-height: 35px;
  font-size: 15px;
  color: #666666;
  width: 80px;
}

.intext {
  width: 190px;
  border-radius: 50px;
  background-color: #F5F5F5;
  padding-left: 15px;
  padding-right: 30px;
}

.arrow02 {
  width: 12px;
  height: 8px;
  margin-left: 285px;
  margin-top: -100px;
}

.yzm {
  margin: -20px auto;
  width: 300px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.yztitle {
  line-height: 35px;
  font-size: 15px;
  color: #666666;
  width: 80px;
}

.inbox {
  width: 190px;
  height: 35px;
  display: flex;
  /* border: solid #FFFFFF; */
  flex-direction: row;
  justify-content: space-between;
}

.inyzm {
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 50px;
  width: 100px;
}

.yzcode {
  text-align: center;
  font-weight: 600;
  width: 60px;
  line-height: 42.5px;
  color: #2504be;
  background-color: #FFFFFF;
}

.cxbtn {
  margin-top: 50px;
  width: 300px;
  height: 42.5px;
  line-height: 42.5px;
  margin-left: 10px;
  text-align: center;
  background-color: #244991;
  border-radius: 50px;
  font-size: 18px;
  color: #FFFFFF;
}

.conList {
  width: 100%;
  height: 44px;
  position: relative;
  background: #f4f0f2;
}

.swiper-container {
  //width: 353px;
  height: 100%;
  margin: 0 auto;
}

.swiper-container {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;
}

.swiper-wrapper {
  //width: 353px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100vw - 100px);
}

.swiper-container-android .swiper-slide, .swiper-wrapper {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

.swiper-wrapper {
  position: relative;
  //width: 353px;
  height: 100%;
  z-index: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-transition-property: -webkit-transform;
  transition-property: -webkit-transform;
  -o-transition-property: transform;
  transition-property: transform;
  transition-property: transform, -webkit-transform;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}

.swiper-slide {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 33.27px;
  /* width: 103px !important; */
}

.swiper-slide p {
  text-align: center;
}

.swiper-slide p {
  width: 100%;
  /* height: 100%; */
  font-family: MicrosoftYaHei;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
  align-items: center;
  line-height: 39px;
}

.swiper-container .swiper-notification {
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
  opacity: 0;
  z-index: -1000;
}

.swiper-button-next {
  right: 11px;
}

.swiper-button-next, .swiper-button-prev {
  width: 12px;
  height: 25px;
  background-color: #399bda;
  display: flex;
  align-items: center;
  justify-content: center;
}

.swiper-button-next:after, .swiper-button-prev:after {
  font-family: swiper-icons;
  font-size: var(--swiper-navigation-size);
  text-transform: none !important;
  letter-spacing: 0;
  text-transform: none;
  font-variant: initial;
  line-height: 1;
  font-size: 12px;
  color: #fff;
}

.swiper-button-next, .swiper-button-prev {
  position: absolute;
  margin-top: -34px !important;
  z-index: 10;
  cursor: pointer;
  background-position: center;
  background-repeat: no-repeat;
  top: 44px !important;
}

.nav_position {
  height: 38px;
  background: #fff;
}

.nav_position ul {
  height: 100%;
  display: flex;
  align-items: center;
  margin-left: 14px;
}

.homeIcon {
  width: 14px;
  height: 14px;
  margin-right: 9px;
  margin-top: -9px;
}

.homeIcon img {
  width: 100%;
  height: 100%;
}

.nav_position ul li {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #999999;
  cursor: pointer;

  a {
    color: #333;
    font-size: 12px;
    text-decoration: none;
  }
}

.nav_position ul li span {
  margin: 0 5px;
}

.viewbox {
  margin: 10px;
}

.source {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

.content {
  padding: 20px 0;
}

.line {
  display: flex;
  align-items: center;

}

.l-2 {
  color: #a1a1a1;
  margin-left: 10px;
}

.line:last-child {
  margin-top: 10px;
}

.newsitem-title {
  width: 100%;
  padding: 20px;
  text-align: center;
}

.wenti ul, .peiXun ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
}

.img_list li {
  list-style: none;
  width: calc((100% - 40px) / 2);
}

.wenti p.peoImg, .peiXun p.peoImg {
  width: 100%;
  height: 134px
}

.wenti ul li img, .peiXun ul li img {
  width: 100%;
  height: 100%;
}

.wenti ul li p.textPeo, .peiXun ul li p.textPeo {
  text-align: center;
  width: 100%;
  height: 18px;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  margin: 8px 0;
  font-size: 12px;
  color: #000000;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* 添加一些样式 */
.swiper-container {
  overflow: hidden;
  position: relative;
  //width: calc(118px * 3); /* 3个slide的宽度 */
  margin: 0 auto;
}

.swiper-wrapper {
  display: flex;
  transition: transform 0.3s ease;
}

.swiper-slide {
  flex-shrink: 0;
  text-align: center;
  cursor: pointer;
}

.swiper-slide p {
  margin: 0;
  padding: 10px 0;
  transition: color 0.3s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}


/* 禁用状态样式 */
.swiper-button-disabled {
  color: #ccc !important;
  cursor: not-allowed !important;
}

.swiper-button-next:not(.swiper-button-disabled):hover,
.swiper-button-prev:not(.swiper-button-disabled):hover {
  background: #e0e0e0;
}

.conList {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 50px; /* 为箭头留出空间 */
}

.zhuanjia .line {
  border: 1px dotted #d0d0d0;
  margin: 26px 0;
}

.zhuanjia .imgIcon {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.zhuanjia .jieshao {
  margin-top: 26px;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
}

.zhuanjia .imgIcon .imgs {
  width: 85px;
  height: 116px;
}

.zhuanjia .imgIcon .word {
  margin-top: 10px;
}

.zhuanjia .imgIcon .word .lanzi {
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0px;
  color: #399bda;
}
</style>
